import React from "react";
import styles from "./affiliate.module.css";
import { PolyG, PolyP, SquareG, SquareO, UserIcon } from "../../../svg";
import { useLocation, useNavigate } from "react-router-dom";

import headerStyle from "../../header/header.module.css"

const Affiliate = () => {
    const location = useLocation();

    const navigate = useNavigate();


    return (
        <div className={styles.containermain}>


            <div className={headerStyle.container}>
                <div className={headerStyle.mainHeader}>
                    <div className={headerStyle.menuflex}>
                        <img src="/assets/logo.png" onClick={() => navigate("/")} className={styles.logo} alt="" />
                    </div>


                    {/* <div className={`${headerStyle.opened} ${styles.userStyle} `}> */}
                    <div style={{ color: "white", display: "flex", justifyContent: "center", alignItems: "center", background: "#1D83F8", padding: "1%", borderRadius: "70px", cursor: "pointer", width: "" }} onClick={() => navigate("/")}>
                        {/* <UserIcon /> */}  Website
                    </div>
                    {/* </div> */}

                </div>

            </div>



            <div style={{ position: 'absolute', top: '15%' }}>
                <SquareO />
            </div>
            <div style={{ position: 'absolute', top: '25%', right: '13%' }}>
                <SquareG />
            </div>
            <div style={{ position: 'absolute', top: '32%', left: '13%' }}>
                <PolyG />
            </div>
            <div style={{ position: 'absolute', top: '42%', right: '10%' }}>
                <PolyP />
            </div>
            <div className={styles.container}>
                <h2 className={styles.title}>Recommend Products. Earn Advertising Fees.</h2>
                <p className={styles.description}>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    Lorem Ipsum has been the industry's standard dummy text.
                </p>
                <button className={styles.button} onClick={() => navigate('/affiliate/login')}>Login/Register</button>

                <div className={styles.cardsContainer}>
                    <div className={`${styles.card} ${styles.signup}`}>
                        <h3>Signup</h3>
                        <p>
                            Join tons of thousands of creators, publishers, and bloggers who are working
                            with the Amazon Associates Program.
                        </p>
                    </div>
                    <div className={`${styles.card} ${styles.recommend}`}>
                        <h3>Recommend</h3>
                        <p>
                            Share millions of products with your audience. We have customized linking tools
                            for large publishers, individual bloggers, and social media influencers.
                        </p>
                    </div>
                    <div className={`${styles.card} ${styles.earn}`}>
                        <h3>Earn</h3>
                        <p>
                            Earn up to 10% in affiliate fees from qualifying purchases and programs.
                            Our competitive conversion rates help maximize earnings.
                        </p>
                    </div>
                </div>
            </div>
            <div className={styles.welcome}>
                <h2 className={styles.wtitle}>Their businesses finally found an all- in-one home with kinsgter. So can yours.</h2>
                <p className={styles.wdescription}>
                    Welcome to one of the largest affiliate marketing programs in the world. The kingster Associates Program helps content creators, publishers and bloggers monetize their traffic. associates use easy link-building tools to direct their audience to their recommendations, and earn from qualifying purchases and programs.
                </p>
            </div>
        </div>
    );
};

export default Affiliate;
